import * as React from "react";
import { useHistory } from "react-router";

import { CampaignListContent } from "@/components/Lists/CampaignListContent";
import { useAccountSettings, URLS, useSocialCoachSession } from "@/utils";
import { WebComponents } from "@/interfaces";
import "./styles.scss";
import { PageWrapper } from "@/components/PageWrapper";

export const Campaigns: React.FC = () => {
  const history = useHistory();
  const { coachId } = useSocialCoachSession();
  const { hasWritePermission } = useAccountSettings();
  const writePermission = hasWritePermission(WebComponents.CAMPAIGNS);

  const addCampaignHandler = () => {
    localStorage.removeItem("coachNewCampaignStep");
    localStorage.removeItem("coachCampaign");
    history.push(URLS.coach.newCampaigns);
  };

  const actions = writePermission
    ? [
        {
          text: "New Campaign",
          onClick: addCampaignHandler,
        },
      ]
    : [];

  return (
    <PageWrapper title="Campaigns" actions={actions}>
      {coachId && <CampaignListContent coachId={coachId.toString()} />}
    </PageWrapper>
  );
};
